var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAnimationIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 46,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M62 0a12 12 0 0 0-12 12v22a12 12 0 0 0 12 12h22a12 12 0 0 0 12-12V12A12 12 0 0 0 84 0H62Zm3 8a7 7 0 0 0-7 7v16a7 7 0 0 0 7 7h16a7 7 0 0 0 7-7V15a7 7 0 0 0-7-7H65ZM12 0A12 12 0 0 0 0 12v22a12 12 0 0 0 12 12h22a12 12 0 0 0 12-12V12A12 12 0 0 0 34 0H12Zm23.6 24.7a2 2 0 0 0 0-3.4l-20-13.5a2 2 0 0 0-3.1 1.7v27a2 2 0 0 0 3.1 1.7l20-13.5Z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnimationIcon);
export default __webpack_public_path__ + "static/media/animation-icon.6252e2bd8a389cb77e41bc4212f37e6f.svg";
export { ForwardRef as ReactComponent };